import { render } from "./VF-inputPassword.vue?vue&type=template&id=56512cb2"
import script from "./VF-inputPassword.vue?vue&type=script&lang=js"
export * from "./VF-inputPassword.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__